import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '../BaseComponents';
import { useTheme } from '../theme';
import { Amenity } from './types';
import { amenitiesIcons, leafIcon } from './icons';

interface Props {
	amenities: Amenity[];
	isEco?: boolean;
	filterAvailable?: boolean;
	className?: string;
}

const Amenities: React.FC<Props> = React.memo(({ amenities, isEco, filterAvailable = true, className }) => {
	const { Amenities: css } = useTheme('Amenities');
	const { t } = useTranslation();

	if (!amenities?.length) {
		return null;
	}

	let filterAmenities = amenities.filter(amenity => amenitiesIcons?.[amenity.type]);

	if (filterAvailable) {
		filterAmenities = filterAmenities.filter(amenity => amenity.available);
	}

	if (!filterAmenities.length) {
		return null;
	}

	filterAmenities = [...filterAmenities].sort((a, b) =>
		a.available === b.available ? 0 : a.available && b.available ? -1 : 1
	);

	return (
		<div className={cn(css.amenities, className)}>
			{filterAmenities.map(amenity => (
				<span
					key={amenity.type}
					className={cn(css.amenities__item, {
						[css.amenities__item_unavailable]: !amenity.available
					})}
				>
					<Tooltip
						key={amenity.type}
						title={
							amenity.available
								? amenity.description
								: t('DesktopFlightInfo:Service is unavailable on this flight')
						}
						enterTouchDelay={0}
					>
						{amenitiesIcons[amenity.type]}
					</Tooltip>
				</span>
			))}

			{isEco && (
				<Tooltip title={t('DesktopFlightInfo:Eco-friendly')}>
					<span className={css.amenities__item}>{leafIcon}</span>
				</Tooltip>
			)}
		</div>
	);
});

export default Amenities;
